import React from "react";
import { Link } from "react-router-dom"; // Link import
import styled from "styled-components";

import arrowFirstIcon from "../../assets/images/ico_arrow_first.png";
import arrowPrevIcon from "../../assets/images/ico_arrow_prev.png";
import arrowNextIcon from "../../assets/images/ico_arrow_next.png";
import arrowLastIcon from "../../assets/images/ico_arrow_last.png";

const PagerWrap = styled.div`
  text-align: center;
  margin-bottom: 30px;

  * {
    vertical-align: middle;
  }

  a {
    display: inline-block;
    padding: 0 15px;
    color: #888;

    &:hover {
      color: #00aad2;
      text-decoration: underline;
    }

    &.active {
      color: #00aad2;
      text-decoration: underline;
    }
  }

  .btn_arrow {
    padding: 0 3px;
  }
`;

const PageBar = ({
  TotalCount,
  CurrentPage,
  CountPerPage,
  MaxPageBarCount,
  onPageСhange,
}) => {
  if (TotalCount > 0) {
    CountPerPage = CountPerPage > 0 ? CountPerPage : 1;
    const sp = CurrentPage - ((CurrentPage - 1) % MaxPageBarCount);
    const tp = Math.ceil(TotalCount / CountPerPage);

    return (
      <PagerWrap>
        {sp - MaxPageBarCount > 0 ? (
          <>
            <Link to="#" title="First" onClick={() => onPageСhange(1)}>
              <img src={arrowFirstIcon} alt="First" />
            </Link>
            <Link to="#" title="Prev" onClick={() => onPageСhange(sp - 1)}>
              <img src={arrowPrevIcon} alt="Prev" />
            </Link>
          </>
        ) : (
          <>
            <Link to="#" title="First" onClick={() => onPageСhange(1)}>
              <img src={arrowFirstIcon} alt="First" />
            </Link>
            <Link to="#" title="Prev">
              <img src={arrowPrevIcon} alt="Prev" />
            </Link>
          </>
        )}

        {Array.from({ length: MaxPageBarCount }).map((_, n) => {
          const pageNum = sp + n;
          if (pageNum <= tp) {
            return (
              <Link
                key={pageNum}
                className={pageNum === CurrentPage ? "active" : ""}
                to="#"
                onClick={
                  pageNum === CurrentPage
                    ? undefined
                    : () => onPageСhange(pageNum)
                }
              >
                {pageNum}
              </Link>
            );
          }
          return null;
        })}

        {sp + MaxPageBarCount <= tp ? (
          <>
            <Link
              to="#"
              title="Next"
              onClick={() => onPageСhange(sp + MaxPageBarCount)}
            >
              <img src={arrowNextIcon} alt="Next" />
            </Link>
            <Link to="#" title="Last" onClick={() => onPageСhange(tp)}>
              <img src={arrowLastIcon} alt="Last" />
            </Link>
          </>
        ) : (
          <>
            <Link to="#" title="Next">
              <img src={arrowNextIcon} alt="Next" />
            </Link>
            <Link to="#" title="Last" onClick={() => onPageСhange(tp)}>
              <img src={arrowLastIcon} alt="Last" />
            </Link>
          </>
        )}
      </PagerWrap>
    );
  } else {
    return (
      <PagerWrap>
        <Link to="#" className="btn_arrow">
          <img src={arrowFirstIcon} alt="First" />
        </Link>
        <Link to="#" className="btn_arrow">
          <img src={arrowPrevIcon} alt="Prev" />
        </Link>
        <Link to="#" className="btn_arrow">
          <img src={arrowNextIcon} alt="Next" />
        </Link>
        <Link to="#" className="btn_arrow">
          <img src={arrowLastIcon} alt="Last" />
        </Link>
      </PagerWrap>
    );
  }
};

export default PageBar;
